module.exports = __webpack_public_path__ + "static/media/Cart display_Popupcart.ee2820d3.gif";